import './tailwind.css'
import './i18n'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from './components/ui/provider'
import { Toaster } from './components/ui/toaster'
import { PortalFonts } from './components/PortalFonts'
import App from './App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <PortalFonts />
          <App />
        </BrowserRouter>
      </QueryClientProvider>
      <Toaster />
    </Provider>
  </React.StrictMode>
)
